const isSuccessfulContactMutationResult = result => {
    return !!(result
        && result.data
        && result.data.updateVendorApprovalContact
        && result.data.updateVendorApprovalContact.successPayload
        && result.data.updateVendorApprovalContact.successPayload.success === true);
};

module.exports = {
    isSuccessfulContactMutationResult
};
